import { CdkCell, CdkCellDef, CdkColumnDef, CdkHeaderCell, CdkHeaderCellDef } from '@angular/cdk/table';
import { AsyncPipe, KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    BaseTableModule,
    OnDestroyBase,
    SelectableRow,
    TableFilterService,
    TableSortService,
} from '@os-components';
import { Observable, takeUntil } from 'rxjs';
import { FilterTypes } from '../../../../../../../../../lib-os-components/src/lib/components/table/components/filters/filter.interface';
import { GearOilOverviewTableElement } from '../gear-oil-overview/gear-oil-overview.component';

@Component({
    selector: 'ecs-gear-oil-overview-table',
    templateUrl: './gear-oil-overview-table.component.html',
    styleUrls: ['./gear-oil-overview-table.component.scss'],
    providers: [TableFilterService, TableSortService],
    imports: [
        BaseTableModule,
        CdkColumnDef,
        CdkHeaderCellDef,
        CdkHeaderCell,
        CdkCellDef,
        CdkCell,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class GearOilOverviewTableComponent extends OnDestroyBase implements OnInit {
    @Input() public items?: Observable<SelectableRow<GearOilOverviewTableElement>[]>;

    @Input() public columns: string[] | null = null;
    @Input() public hideMarkedBar = false;
    @Input() public showCheckboxColumn = true;

    @Output() public rowSelect = new EventEmitter<SelectableRow<GearOilOverviewTableElement>[]>();

    public viscosityFilterValues: KeyValue<string, string>[] = [];
    public lubricantTypeFilterValues: KeyValue<string, string>[] = [];
    public gearboxFilterValues: KeyValue<string, string>[] = [];
    public gearboxKeys: string[] = [];
    public characteristicsFilterValues: KeyValue<string, string>[] = [];
    public sizesFilterValues: KeyValue<string, string>[] = [];

    public filterTypes = FilterTypes;

    public constructor() {
        super();
    }

    public ngOnInit() {
        if (this.items) {
            this.items
                .pipe(takeUntil(this.destroySubject))
                .subscribe((element: SelectableRow<GearOilOverviewTableElement>[]) => {
                    for (const val of element) {
                        if (!this.viscosityFilterValues.some((item) => item.key === val.rowData.viscosity)) {
                            this.viscosityFilterValues.push({
                                key: val.rowData.viscosity,
                                value: val.rowData.viscosity,
                            });
                        }
                        if (
                            !this.lubricantTypeFilterValues.some(
                                (item) => item.key === val.rowData.lubricantType
                            )
                        ) {
                            this.lubricantTypeFilterValues.push({
                                key: val.rowData.lubricantType,
                                value: val.rowData.lubricantType,
                            });
                        }
                        if (!this.sizesFilterValues.some((item) => item.key === val.rowData.size)) {
                            this.sizesFilterValues.push({
                                key: val.rowData.size,
                                value: val.rowData.size,
                            });
                        }

                        val.rowData.characteristics.forEach((item) => {
                            if (!this.characteristicsFilterValues.some((e) => e.key === item.name)) {
                                this.characteristicsFilterValues.push({
                                    key: item.name,
                                    value: item.name,
                                });
                            }
                        });
                        val.rowData.approvedGearbox.forEach((item) => {
                            if (!this.gearboxFilterValues.some((e) => e.key === item.name)) {
                                this.gearboxFilterValues.push({
                                    key: item.name,
                                    value: item.name,
                                });
                            }
                        });
                    }
                    this.viscosityFilterValues.sort((a, b) => {
                        const keyA = parseInt(a.key, 10);
                        const keyB = parseInt(b.key, 10);

                        return keyA - keyB;
                    });
                    this.sizesFilterValues.sort((a, b) => {
                        const matchA = a.key.match(/\d+/);
                        const matchB = b.key.match(/\d+/);

                        if (matchA && matchB) {
                            const valueA = parseInt(matchA[0], 10);
                            const valueB = parseInt(matchB[0], 10);

                            return valueA - valueB;
                        }

                        return 0;
                    });
                });
        }
    }

    public onRowSelect(event: SelectableRow<GearOilOverviewTableElement>[]) {
        this.rowSelect.emit(event);
    }
}
